import { Transform, Type } from 'class-transformer';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { PostDto } from '../dto/post.dto';
import { jsonStringToObject } from '../../types-transformers/order-transformers';
import { IsArray, IsInt, IsOptional, IsString, Min } from 'class-validator';
import { stringToBoolean } from '../../types-transformers';

export class PostFilter implements OrderFilter<PostDto>, PaginationFilter {
	@Transform(jsonStringToObject)
	@IsOptional()
	public orderedBy?: OrderParamPair<PostDto>[] | null;

	@IsOptional()
	@IsString()
	public search?: string;

	@Transform(stringToBoolean)
	@IsOptional()
	public isActive?: boolean;

	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	public tags?: string[];

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	public pageSize?: number | null;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	public page?: number | null;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(0)
	public offset?: number | null;
}
